(function ($) {
  'use strict';

  $(document).ready(function () {
    // State object
    let state = {
      intent: null, // 'pot-or-container' or 'ground'
      shape: null, // 'rectangle', 'square', 'round'
      dims: {}, // dimensions for pot-or-container: { length, width, side, diameter, depth }
      groundDims: {}, // dimensions for ground: { length, width, depth }
      plantEntries: [], // { liters, qty, title, subtitle }
      plantsConfirmed: false,
      dimsConfirmed: false,
      extras: {},
    };

    // Load WooCommerce products from data attribute
    let products = [];
    let productsAvailable = $('#pgc-available-products .pgc-product-row');

    if (productsAvailable.length) {
      productsAvailable.each(function (i, item) {
        const id = $(item).data('id');
        const liters = $(item).data('liters');
        products.push({ id: id, volume: liters });
      });
    }

    // Default dimensions
    let defaultDims = {
      rectangle: { length: 80, width: 50, depth: 40 },
      square: { side: 50, depth: 40 },
      round: { diameter: 50, depth: 40 },
    };
    let defaultGroundDims = { length: 200, width: 100, depth: 30 };

    // Initialize state dimensions
    state.dims = $.extend(true, {}, defaultDims.rectangle);
    state.groundDims = $.extend(true, {}, defaultGroundDims);

    // Initialize plants with a default row
    function initDefaultPlants() {
      let $defaultOpt = $('#pgc-plant-sizes-source option[selected]');
      if ($defaultOpt.length === 0) {
        $defaultOpt = $('#pgc-plant-sizes-source option').first();
      }
      if ($defaultOpt.length > 0) {
        state.plantEntries = [
          {
            liters: parseFloat($defaultOpt.val()) || 5,
            qty: 1,
            title: $defaultOpt.data('title') || 'Middelgrote plant',
            subtitle: $defaultOpt.data('subtitle') || '± 5 liter pot',
          },
        ];
      } else {
        state.plantEntries = [
          {
            liters: 5,
            qty: 1,
            title: 'Middelgrote plant',
            subtitle: '± 5 liter pot',
          },
        ];
      }
      state.plantsConfirmed = false;
    }
    initDefaultPlants();

    // ─── INITIALIZE SLIDERS ───
    $('.pgc-range-input').each(function () {
      let $slider = $(this);
      let val = parseFloat($slider.val()) || 0;
      updateSliderFill($slider, val);
    });

    // Update slider track fill percentage & text value
    function updateSliderFill($slider, val) {
      let min = parseFloat($slider.attr('min')) || 0;
      let max = parseFloat($slider.attr('max')) || 100;
      let pct = ((val - min) / (max - min)) * 100;

      $slider
        .closest('.pgc-slider-wrap')
        .find('.pgc-slider-fill')
        .css('width', pct + '%');
      $slider
        .closest('.pgc-slider-container')
        .find('.pgc-slider-val')
        .text(val);
    }

    // ─── STEP MANAGE & FLOW ───
    function getVisibleSteps() {
      if (state.intent === 'pot-or-container') {
        return ['intent', 'shape', 'dims', 'plants', 'result'];
      } else if (state.intent === 'ground') {
        return ['intent', 'dims', 'plants', 'result'];
      }
      return ['intent', 'shape', 'dims', 'plants', 'result'];
    }

    function updateStepsUI() {
      let visible = getVisibleSteps();

      // Hide/Show accordion items
      $('.pgc-accordion-item').addClass('d-none');

      visible.forEach(function (stepId, idx) {
        let $item = $('#step-' + stepId);
        $item.removeClass('d-none');

        // Update badge number
        let $badge = $item.find('.pgc-accordion-step-num');
        $badge.text(idx + 1);
      });

      // Update Progress Bar
      let currentOpenId =
        $('.pgc-accordion-item.open').data('step-id') || 'intent';
      let currentIdx = visible.indexOf(currentOpenId);
      if (currentIdx === -1) currentIdx = 0;

      let total = visible.length;
      let currentStepNum = currentIdx + 1;

      $('.pgc-current-step-num').text(currentStepNum);
      $('.pgc-total-steps-num').text(total);

      let progressPct = (currentStepNum / total) * 100;
      $('#pgc-progress-fill').css('width', progressPct + '%');

      //console.log(state);
    }

    function updateBadges() {
      let visible = getVisibleSteps();
      visible.forEach(function (stepId) {
        let $item = $('#step-' + stepId);
        let $badge = $item.find('.pgc-accordion-step-num');

        let done = isStepDone(stepId);
        let open = $item.hasClass('open');

        $badge.removeClass('pending active is-done');
        $item.removeClass('done pending');

        if (open) {
          $badge.addClass('active');
        } else if (done) {
          $badge.addClass('is-done');
          $item.addClass('done');

          // Show summary
          $item.find('.pgc-accordion-summary').removeClass('d-none');
          $item
            .find('.pgc-accordion-summary-text')
            .text(getStepSummary(stepId));
        } else {
          $badge.addClass('pending');
          $item.addClass('pending');
          $item.find('.pgc-accordion-summary').addClass('d-none');
        }
      });
    }

    function isStepDone(stepId) {
      switch (stepId) {
        case 'intent':
          return state.intent !== null;
        case 'shape':
          return state.shape !== null;
        case 'dims':
          return state.dimsConfirmed;
        case 'plants':
          return state.plantsConfirmed;
        default:
          return false;
      }
    }

    function getStepSummary(stepId) {
      let totalQty = 0;
      switch (stepId) {
        case 'intent':
          return state.intent === 'pot-or-container'
            ? 'Pot of bak'
            : 'In de grond';
        case 'shape':
          if (state.shape === 'rectangle') return 'Rechthoek';
          if (state.shape === 'square') return 'Vierkant';
          if (state.shape === 'round') return 'Rond';
          return '';
        case 'dims':
          if (state.intent === 'pot-or-container') {
            if (state.shape === 'rectangle') {
              return (
                state.dims.length +
                '×' +
                state.dims.width +
                '×' +
                state.dims.depth +
                ' cm'
              );
            }
            if (state.shape === 'square') {
              return (
                state.dims.side +
                '×' +
                state.dims.side +
                '×' +
                state.dims.depth +
                ' cm'
              );
            }
            if (state.shape === 'round') {
              return (
                'Ø ' + state.dims.diameter + ' · ' + state.dims.depth + ' cm'
              );
            }
          } else {
            return (
              state.groundDims.length +
              '×' +
              state.groundDims.width +
              ' · ' +
              state.groundDims.depth +
              ' cm'
            );
          }
          return '';
        case 'plants':
          state.plantEntries.forEach(function (e) {
            totalQty += e.qty;
          });
          return totalQty + ' plant' + (totalQty !== 1 ? 'en' : '');
        default:
          return '';
      }
    }

    function openStep(stepId) {
      // Hide others
      $('.pgc-accordion-item').removeClass('open');
      $('#step-' + stepId)
        .addClass('open')
        .removeClass('pending');

      // Trigger Bootstrap collapse
      //$('.pgc-accordion-body').collapse('hide');
      $('#collapse-' + stepId).collapse('show');

      updateStepsUI();
      updateBadges();
    }

    //  - - - - - STEPS 1 & 2 heandler (intent / shape selection) - - - - //
    $('.pgc-options').on('click', '.pgc-option-card', function () {
      const $this = $(this);
      const $parent = $this.closest('.pgc-options');
      const type = $parent.data('type'); // 'intent' or 'shape'
      const val = $this.data(type);

      if (!val) return;

      // 1. Update Core State & UI Selection
      state[type] = val;
      $this.addClass('selected').siblings().removeClass('selected');

      // 2. Handle Specific Step Logic
      if (type === 'intent') {
        // Reset downstream states
        Object.assign(state, {
          shape: null,
          dimsConfirmed: false,
          plantsConfirmed: false,
        });
        initDefaultPlants();

        setTimeout(() => {
          if (val === 'pot-or-container') {
            openStep('shape');
          } else {
            setupSliders();
            openStep('dims');
          }
        }, 300);
      } else if (type === 'shape') {
        state.dimsConfirmed = false;
        state.dims = $.extend(true, {}, defaultDims[val]);

        setTimeout(() => {
          setupSliders();
          openStep('dims');
        }, 300);
      }
    });

    // Setup slider visibilities and initial values
    function setupSliders() {
      $('.pgc-slider-container').addClass('d-none');

      if (state.intent === 'pot-or-container') {
        $('.pgc-slider-container[data-type="pot-or-container"]').each(
          function () {
            let shapes = ($(this).data('shape') || '').split(',');
            if (shapes.indexOf(state.shape) >= 0) {
              $(this).removeClass('d-none');

              let measure = $(this).data('measure');
              let val =
                state.dims[measure] || $(this).find('input').attr('min');
              let $input = $(this).find('input');

              $input.val(val);
              updateSliderFill($input, val);
            }
          }
        );
      } else if (state.intent === 'ground') {
        $('.pgc-slider-container[data-type="ground"]').each(function () {
          $(this).removeClass('d-none');

          let measure = $(this).data('measure');
          let val =
            state.groundDims[measure] || $(this).find('input').attr('min');
          let $input = $(this).find('input');

          $input.val(val);
          updateSliderFill($input, val);
        });
      }
    }

    // Slider dragging input listener
    $('.pgc-range-input').on('input change', function () {
      let $slider = $(this);
      let val = parseInt($slider.val()) || 0;
      let measure = $slider.data('measure');

      updateSliderFill($slider, val);

      if (state.intent === 'pot-or-container') {
        state.dims[measure] = val;
      } else if (state.intent === 'ground') {
        state.groundDims[measure] = val;
      }
    });

    // Dims Verder button click
    $('#pgc-btn-dims-next').on('click', function () {
      state.dimsConfirmed = true;
      openStep('plants');
    });

    // ─── PLANTS DYNAMIC ROW MANAGEMENT ───
    function renderPlants() {
      let $list = $('#pgc-plants-list');
      $list.empty();
      let isMulti = state.plantEntries.length > 1;

      state.plantEntries.forEach(function (entry, index) {
        let $row = $('#pgc-plant-row-source .pgc-plant-row').clone();
        if (!isMulti) {
          $row.addClass('single');
        }

        // Set data from state
        $row.find('.pgc-qty-value').val(entry.qty);

        $row.data('entry-index', index);
        $row.find('.pgc-plant-size-btn-label').text(entry.title);
        $row.find('.pgc-plant-size-btn-size').text(entry.subtitle);
        $row.find('.pgc-plant-size-option').removeClass('selected');
        $row
          .find('.pgc-plant-size-option[data-value="' + entry.liters + '"]')
          .addClass('selected');
        $list.append($row);

        initPlantSizeDropdown();
        qtyCounter();
      });
    }

    // Add plant row
    $('#pgc-btn-add-plant').on('click', function () {
      let $defaultRow = $('#pgc-plant-row-source .pgc-plant-row');
      let $defaultOpt = $defaultRow.find('.pgc-plant-size-option.selected');

      state.plantEntries.push({
        liters: parseInt($defaultOpt?.data('value')) || 1,
        qty: parseInt($defaultRow?.find('.pgc-qty-value')?.val()) || 1,
        title:
          $defaultOpt?.find('.pgc-plant-size-option__title').text() ||
          'Klein plantje',
        subtitle:
          $defaultOpt?.find('.pgc-plant-size-option__subtitle').text() ||
          '± 1 liter pot',
      });

      renderPlants();
    });

    // Remove row
    $(document).on('click', '.pgc-btn-remove-row', function () {
      let index = $(this).closest('.pgc-plant-row').data('entry-index');
      state.plantEntries.splice(index, 1);
      renderPlants();
    });

    // Plants Verder button click
    $('#pgc-btn-plants-next').on('click', function () {
      state.plantsConfirmed = true;
      calculateResult();
      openStep('result');
    });

    // Initialize plants view
    renderPlants();

    // ─── TOGGLES & MARGINS ───
    $('.pgc-extra').on('change', 'input[type="checkbox"]', function () {
      let checked = $(this).is(':checked');
      let $extra = $(this).closest('.pgc-extra');
      let slug = $extra.data('slug');
      let multi = $extra.data('multi');
      let value = $extra.find('input[type="range"]').val();

      if (slug) {
        state.extras[`${slug}`] = {
          active: checked,
          value: parseInt(value),
          multi: parseFloat(multi),
        };
      }

      if (checked) {
        $extra.find('.pgc-extra-main').slideDown(200);
      } else {
        $extra.find('.pgc-extra-main').slideUp(200);
      }

      calculateResult();
    });

    $('.pgc-extra').on('input change', 'input[type="range"]', function () {
      let $extra = $(this).closest('.pgc-extra');
      let slug = $extra.data('slug');
      let value = parseInt($(this).val());
      let $displayValue = $extra.find('.pgc-input-value');

      if (state.extras[`${slug}`] != undefined) {
        state.extras[`${slug}`].value = value || parseInt($(this).attr('min'));
      }

      if ($displayValue.length) {
        $displayValue.text(value);
      }

      calculateResult();
    });

    // ─── VOLUME CALCULATION ───
    function calcRawVolume() {
      if (state.intent === 'pot-or-container') {
        if (state.plantsConfirmed) {
          let sum = 0;
          state.plantEntries.forEach(function (e) {
            sum += e.liters * e.qty;
          });
          return sum;
        }

        // Otherwise calculate pot volume based on dimensions
        let dims = state.dims;
        if (state.shape === 'rectangle') {
          return (dims.length * dims.width * dims.depth) / 1000;
        } else if (state.shape === 'square') {
          return (dims.side * dims.side * dims.depth) / 1000;
        } else if (state.shape === 'round') {
          let r = dims.diameter / 2;
          return (Math.PI * r * r * dims.depth) / 1000;
        }
      } else if (state.intent === 'ground') {
        let gd = state.groundDims;
        return (gd.length * gd.width * gd.depth) / 1000;
      }
      return 0;
    }

    function calculateResult() {
      let rawLiters = calcRawVolume();

      // Apply/calculate extras
      let finalLiters = rawLiters;
      for (const [key, data] of Object.entries(state.extras)) {
        console.log(key, data);
        if (data.active) {
          let multiplier = data.multi || 1;
          finalLiters = finalLiters * (1 + (data.value / 100) * multiplier);
        }
      }

      let displayLiters = Math.ceil(finalLiters);

      // Count up animation for number
      animateCountUp($('#pgc-result-liters'), displayLiters);

      // Recommends soil bags and hydro bags
      let recommendedBags = products
        ? getRecommendedBags(finalLiters, products)
        : [];

      renderRecommendedCards(recommendedBags);
    }

    function getRecommendedBags(liters, productList) {
      let total = Math.ceil(liters);
      if (total <= 0 || productList.length === 0) return [];
      let recommendations = [];

      // Sort products descending by volume
      let sortedProds = productList.slice().sort(function (a, b) {
        return b.volume - a.volume;
      });

      sortedProds.forEach((prod) => {
        let count = Math.floor(total / prod.volume);

        if (count * prod.volume < liters) {
          count++;
        }

        if (count > 0) {
          recommendations.push({
            product: prod.id,
            count: count,
          });
        }
      });

      return recommendations;
    }

    function renderRecommendedCards(soilBags) {
      let $container = $('#pgc-recommended-products');
      $container.empty();

      if (soilBags.length === 0) {
        $container.append(
          '<p class="pgc-text-small text-center px-2">Geen aanbeveling beschikbaar.</p>'
        );
        return;
      }

      // Render soil bags
      soilBags.forEach(function (b, idx) {
        $container.append(buildProductCardHTML(b.product, b.count, idx));
      });
    }

    function buildProductCardHTML(product, count, index) {
      let productTmpl = $(
        '#pgc-available-products .pgc-product-row[data-id="' + product + '"]'
      );
      if (productTmpl.length === 0) {
        return;
      }
      let delayClass = 'pgc-delay-' + ((index % 6) + 2);
      let productClone = productTmpl.clone();

      productClone.addClass(delayClass);
      productClone.find('.pgc-product-qty').text(count);
      productClone.find('.pgc-product-btn').attr('data-qty', count);

      return productClone;
    }

    // Animate counter
    function animateCountUp($el, targetVal) {
      let currentVal = parseInt($el.text()) || 0;
      if (currentVal === targetVal) return;

      $({ val: currentVal }).animate(
        { val: targetVal },
        {
          duration: 1200,
          easing: 'swing',
          step: function (now) {
            $el.text(Math.round(now));
          },
          complete: function () {
            $el.text(targetVal);
          },
        }
      );
    }

    // ─── ADD TO WOOCOMMERCE CART ───
    $(document).on('click', '.pgc-product-btn', function () {
      let $btn = $(this);
      let productId = $btn.data('id');
      let quantity = $btn.data('qty') || 1;

      $btn.addClass('loading').prop('disabled', true);

      // AJAX Add to WooCommerce Cart
      $.ajax({
        type: 'POST',
        url: window.wc_add_to_cart_params
          ? window.wc_add_to_cart_params.wc_ajax_url
              .toString()
              .replace('%%endpoint%%', 'add_to_cart')
          : '/?add-to-cart=' + productId,
        data: {
          product_id: productId,
          quantity: quantity,
        },
        success: function (response) {
          $btn
            .removeClass('loading')
            .addClass('success')
            .prop('disabled', false);

          setTimeout(function () {
            $btn.removeClass('success');
            $(document.body).trigger('fkcart_open');
          }, 1000);

          // Refresh mini carts
          $(document).trigger('added_to_cart', [
            response.fragments,
            response.cart_hash,
            $btn,
          ]);
        },
        error: function () {
          // Fallback to query-parameter redirect if AJAX fails
          window.location.href =
            '?add-to-cart=' + productId + '&quantity=' + quantity;
        },
      });
    });

    // ─── ACCORDION MANUAL INTERACTION & RESTRICTION ───
    $(document).on('click', '.pgc-accordion-item.pending', function (e) {
      let $item = $(this);
      e.preventDefault();
      e.stopPropagation();

      $item.addClass('shaking');
      setTimeout(function () {
        $item.removeClass('shaking');
      }, 450);

      // Show hint
      let $hint = $('.pgc-step-hint');
      $hint.fadeIn();
      setTimeout(() => {
        $hint.fadeOut();
      }, 2000);
      return;
    });

    // ─── RESTRENGTH/RESTART CALCULATOR ───
    $('#pgc-btn-restart').on('click', function () {
      resetCalculator();
    });

    $('.pgc-btn-change').on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      let stepId = $(this).closest('.pgc-accordion-item').data('step-id');
      openStep(stepId);
    });

    function resetCalculator() {
      state.intent = null;
      state.shape = null;
      state.dimsConfirmed = false;
      state.plantsConfirmed = false;
      state.extras = {};

      // Reset UI inputs
      $('.pgc-option-card').removeClass('selected');
      $('.pgc-tile').removeClass('selected');
      $('#pgc-margin-tip').show();

      // Reset extras
      $('.pgc-extra').each(function (i, item) {
        $(item).find('input[type="checkbox"]').prop('checked', false);
        $(item).find('.pgc-extra-main').hide();
        let $range = $(item).find('.pgc-range-input');
        $range.val($range.attr('value')).trigger('change');
      });

      state.dims = $.extend(true, {}, defaultDims.rectangle);
      state.groundDims = $.extend(true, {}, defaultGroundDims);

      initDefaultPlants();
      renderPlants();

      // Reset to step 1
      openStep('intent');
    }

    function initPlantSizeDropdown() {
      let $btn = $(document).find('.pgc-plant-size-btn');

      // Toggle open/close on button click
      $btn.each(function () {
        $(this)
          .off('click')
          .on('click', function (e) {
            e.stopPropagation();
            let $dropdown = $(this).siblings('.pgc-plant-size-dropdown');
            let isOpen = $dropdown.is(':visible');
            closePlantDropdowns();
            if (!isOpen) {
              $dropdown.slideDown(150);
              $btn.addClass('is-active');
            }
          });
      });

      // Close when an option inside the dropdown is clicked
      $(document)
        .find('.pgc-plant-size-option')
        .off('click')
        .on('click', function () {
          let $this = $(this);
          let $row = $this.closest('.pgc-plant-row');
          let index = $row.data('entry-index');

          $this.siblings().removeClass('selected');
          $this.addClass('selected');

          state.plantEntries[index].liters =
            parseFloat($this?.data('value')) || 1;
          state.plantEntries[index].title = $this
            ?.find('.pgc-plant-size-option__title')
            .text();
          state.plantEntries[index].subtitle = $this
            ?.find('.pgc-plant-size-option__subtitle')
            .text();

          $row
            .find('.pgc-plant-size-btn-label')
            .text(state.plantEntries[index].title);
          $row
            .find('.pgc-plant-size-btn-size')
            .text(state.plantEntries[index].subtitle);

          closePlantDropdowns();
        });

      // Close on outside click
      $(document).on('click.pgcDropdown', function (e) {
        if (
          !$(e.target).closest('.pgc-plant-size-dropdown').length &&
          !$(e.target).closest($btn).length
        ) {
          closePlantDropdowns();
        }
      });
    }

    function closePlantDropdowns() {
      $(document).find('.pgc-plant-size-dropdown').slideUp(150);
      $(document).find('.pgc-plant-size-btn').removeClass('is-active');
    }

    // QTY Counter
    function qtyCounter() {
      $(document)
        .find('.pgc-qty-counter')
        .each(function () {
          const $input = $(this).find('.pgc-qty-value');

          $(this)
            .find('.pgc-qty-btn')
            .off('click')
            .on('click', function () {
              const isMinus = $(this).attr('type') === 'minus';
              const newVal = (parseInt($input.val()) || 1) + (isMinus ? -1 : 1);

              if (newVal >= 1) $input.val(newVal).trigger('change');
            });

          // Update QTY instanse
          $(this)
            .find('.pgc-qty-value')
            .off('change')
            .on('change', function () {
              let index = $(this).closest('.pgc-plant-row').data('entry-index');
              state.plantEntries[index].qty = parseInt($(this).val());
            });
        });
    }

    // Initialize UI view
    updateStepsUI();
    updateBadges();
  });
})(jQuery);
